"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomEngine = void 0;
const pixi_js_1 = require("pixi.js");
const injets_1 = require("injets");
const room_imager_1 = require("../imager/room.imager");
const human_imager_1 = require("../imager/avatar/human-imager");
const RoomUser_1 = require("./users/RoomUser");
const room_constants_1 = require("./room.constants");
const FloorRenderer_1 = require("./floor/FloorRenderer");
const WallRenderer_1 = require("./wall/WallRenderer");
const application_provider_1 = require("../pixi/application.provider");
let RoomEngine = class RoomEngine {
    constructor(appProvider, roomImager, avatarImager) {
        this.appProvider = appProvider;
        this.roomImager = roomImager;
        this.avatarImager = avatarImager;
        this.container = new pixi_js_1.Container();
        this.users = new Map();
        this.appProvider.app.ticker.add((delta) => this.tick(delta));
    }
    // TODO: GET CURRENT USER
    get currentUser() {
        return this.users.get('abc');
    }
    calcZIndex({ x, y, z }, priority = 1) {
        return (x + y + z) * priority;
    }
    destroy() {
        this.container.removeChild();
        this.users.clear();
    }
    /**
     * TODO: Render Furni
     */
    putFurni() { }
    putUsers(userOptionsDictionary) {
        this.users.clear();
        return Object.entries(userOptionsDictionary)
            .map(([userId, userModel]) => {
            const roomUser = new RoomUser_1.RoomUser(userModel, this);
            this.users.set(userId, roomUser);
            return this.addUserSprite(roomUser);
        });
    }
    updateUsersZIndex() {
        this.users.forEach(roomUser => {
            if (!roomUser.container)
                return;
            roomUser.container.zIndex = this.calcZIndex(roomUser.iso, room_constants_1.PRIORITY.USER);
        });
    }
    tick(delta) {
        this.updateUsersZIndex();
    }
    addUserSprite(roomUser) {
        return __awaiter(this, void 0, void 0, function* () {
            yield roomUser.initSprite();
            this.container.addChild(roomUser.container);
        });
    }
    renderWalls(roomModel) {
        this.wallRenderer = new WallRenderer_1.WallRenderer(this);
        this.wallRenderer.spawn = roomModel.door;
        this.wallRenderer.renderWalls();
    }
    renderFloor() {
        this.floorRenderer = new FloorRenderer_1.FloorRenderer(this);
        this.floorRenderer.renderFloor();
    }
    init(roomModel) {
        return __awaiter(this, void 0, void 0, function* () {
            this.heightmap = roomModel.heightmap;
            this.container.sortableChildren = true;
            this.renderWalls(roomModel);
            this.renderFloor();
            yield Promise.all(this.putUsers(roomModel.roomUserDictionary));
            this.putFurni();
            this.container.sortChildren();
        });
    }
};
RoomEngine = __decorate([
    injets_1.Provider(),
    __metadata("design:paramtypes", [application_provider_1.ApplicationProvider,
        room_imager_1.RoomImager,
        human_imager_1.AvatarImager])
], RoomEngine);
exports.RoomEngine = RoomEngine;
